/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import CachingEmoji from './CachingEmoji';
import { emojiName, emojiShortName, preview, previewImg, previewText } from './styles';
export var EmojiPreviewComponent = function EmojiPreviewComponent(_ref) {
  var emoji = _ref.emoji;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: preview
    }, jsx("span", {
      css: previewImg
    }, jsx(CachingEmoji, {
      key: emoji.id || emoji.shortName,
      emoji: emoji
    })), jsx("div", {
      css: previewText
    }, emoji.name && jsx("div", {
      css: emojiName
    }, emoji.name), jsx("div", {
      css: emojiShortName
    }, emoji.shortName)))
  );
};